import initialState from './initialState';
import { reducer as retrieveOrganizationAccount } from './retrieveOrganizationAccount';
import { reducer as addNewAccount } from './addNewAccount';
import { reducer as updateUserAccount } from './updateUserAccount';
import { reducer as deleteUserAccount } from './deleteUserAccount';
import { reducer as retrieveAllUsers } from './retrieveAllUsers';
const reducers = [
  retrieveOrganizationAccount,
  addNewAccount,
  updateUserAccount,
  deleteUserAccount,
  retrieveAllUsers,
];

export default function reducer(state = initialState, action) {
  return reducers.reduce((s, r) => r(s, action), state);
}



// WEBPACK FOOTER //
// ./src/features/user-management/redux/reducer.js